module.exports = __webpack_public_path__ + "static/media/hero-virtual.d3dee183.mp4";